import { Question, Answer } from './surveyModalStyled';
import { Space } from '@gr-monorepo/common/ui';
import { LogClick } from '../../../../shared/ClickStream';
import RadioButton from '@gr-monorepo/common/ui/RadioButton';
import React from 'react';

export const SurveyRadioQuestion = ({
  ...props
}: {
  question: string;
  answers: string[];
  setAnswer: (value: string) => void;
  answerValue: string;
}) => {
  return (
    <>
      <Question>{props.question}</Question>
      <Space size={4} axis="vertical" />
      <Answer>
        {props.answers.map((el, i, arr) => (
          <React.Fragment key={el}>
            <Space size={12} axis="vertical" />
            <RadioButton
              value={props.answerValue === el}
              selectedRadioColor={'#9965F4'}
              onChange={() => props.setAnswer(el)}
            >
              {el}
            </RadioButton>
          </React.Fragment>
        ))}
      </Answer>
    </>
  );
};
